
import { MediaInfoRawData } from "../../model/MediaInfo.js";
import { MediaPlaylist } from "../../model/MediaPlaylist.js";
import { AbstractFilterablePlaylist } from "./AbstractFilterablePlaylist.js";

export class StaticPlaylist<MI extends MediaInfoRawData<any>> extends AbstractFilterablePlaylist<StaticPlaylist<MI>, MI> {

    constructor(maybePlaylist?: MediaPlaylist<MI>) {
        super(maybePlaylist);
    }

    protected newInstanceForClone(): StaticPlaylist<MI> {
        return new StaticPlaylist<MI>();
    }

}